// js
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AreaCard from '../common/AreaCard';
import {makeGetIsActiveArea} from '../../selectors/dsa/areaSelectors';
import {makeGetAreaUsageProgress} from '../../selectors/dsa/usageSelectors';


function UsageCard({area, isActiveArea, progress, goalsRedirect}) {

  return (
    <AreaCard area={area} page='usage'>
      <p>
        {isActiveArea &&
          <span className='area-card__answered usage-card__answered'>
            { progress.current === progress.total && <i className='icon icon-check-green' /> }
            {`${progress.current}/${progress.total} Complete`}
          </span>
        }
        {!isActiveArea && <span className='area-card__answered usage-card__answered'>n/a</span>}
      </p>
      {!isActiveArea && <i className='icon icon-lock' onClick={goalsRedirect} />}
    </AreaCard>
  );
}

const mapStateToProps = (state, props) => {
  const getIsActiveArea = makeGetIsActiveArea();
  const getAreaUsageProgress = makeGetAreaUsageProgress();
  return {
    isActiveArea: getIsActiveArea(state, props),
    progress: getAreaUsageProgress(state, props)
  };
};

UsageCard.propTypes = {
  area: PropTypes.object.isRequired,
  isActiveArea: PropTypes.bool,
  goalsRedirect: PropTypes.func,
  progress: PropTypes.object
};

export default connect(mapStateToProps)(UsageCard);



// WEBPACK FOOTER //
// ./src/components/usage/UsageCard.js